import styled from 'styled-components'

import SelectField from '@/common/components/SelectField'

export const AdditionalScoreField = styled(SelectField).attrs({
  styles: {
    control: {
      minWidth: '110px',
      height: '23px',
      '> div:first-child': {
        padding: '0px 8px',
      },
    },
    indicatorsContainer: {
      svg: {
        width: 12,
        height: 12,
      },
    },
  },
})`
  margin-bottom: -4px;
`
